export const readableActivityField = field => {
  const labels = {
    job_title: "Job Title",
    department: "Department",
    position: "Designation",
    designation: "Designation",
    experience: "Experience",
    experience_level: "Experience Level",
    difficulty_level: "Difficulty Level",
    min_exp: "Minimum Experience",
    max_exp: "Maximum Experience",
    position: "Designation",
    close_date: "Close Date",
    category: "Category",
    workplace_types: "Workplace",
    reporting_manager: "Reporting Manager",
    agent: "Agent",
    location: "Location",
    state: "State",
    city: "City",
    workplace_type: "Work Type",
    workplace_name: "Work Type",
    shift_timings: "Shift Timings",
    reporting_manager_id: "Reporting Manager",
    shift_timing: "Shift Timing",
    shift: "Shift Timings",
    time_settings: "Question Configuration",
    annual_ctc: "Annual CTC",
    salary_max: "Package/Budget",
    post_to_website: "Website Posting",
    criticality_level: "Difficulty Level",
    openings: "Number of Openings",
    education_level: "Required Education",
    roles_responsibility: "Roles and Responsibilities",
    job_description: "Job Description",
    package: "Package",
    budget: "Budget",
    education: "Education",
    job_description: "Job Description",
    roles_responsibilities: "Roles and Responsibilities",
    social_media_posting: "Social Media Posting",
    first_name: "First Name",
    middle_name: "Middle Name",
    last_name: "Last Name",
    candidate_name: "Candidate Name",
    candidate_email: "Email",
    candidate_phone: "Phone",
    mobile_phone: "Phone",
    current_salary: "Salary",
    expected_salary: "Expected Salary",
    notice_period: "Notice Period",
    current_company: "Current Company",
    skills: "Skills",
    resume: "Resume",
    documents: "Documents",
    previous_stage: "Previous Stage",
    new_stage: "New Stage",
    reason: "Reason",
    rejected_round: "Rejected Round",
    ideal_answer: "Ideal Answer",
    must_have_qualification: "Must-have Qualification",
    skill_name: "Skill Name",
    rating: "Rating",
    proficiency: "Proficiency",
    question_count: "Question Count",
    no_of_questions: "Question Count",
    duration: "Duration",
    cutoff: "Cutoff",
    cutoff_score: "Cutoff Score",
    beginner: "Beginner Questions",
    intermediate: "Intermediate Questions",
    advanced: "Advanced Questions",
    beginner_question_count: "Beginner Questions",
    intermediate_question_count: "Intermediate Questions",
    advanced_question_count: "Advanced Questions",
    beginner_ratio: "Beginner Ratio",
    intermediate_ratio: "Intermediate Ratio",
    advanced_ratio: "Advanced Ratio",
    round_enabled: "Round Enabled",
    enabled: "Enabled",
    is_enabled: "Enabled",
    total_score: "Total Score",
  }

  return (
    labels[field] ||
    String(field || "")
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/[_-]+/g, " ")
      .replace(/\b\w/g, character => character.toUpperCase())
  )
}

export const getActivityChanges = activity => {
  const directChanges = activity?.change_details
  const metadataChanges = activity?.metadata?.changes
  const metadataFields = activity?.metadata?.fields
  const hasEntries = value =>
    value &&
    typeof value === "object" &&
    !Array.isArray(value) &&
    Object.keys(value).length > 0
  const normalizedDirectChanges = hasEntries(directChanges?.changes)
    ? directChanges.changes
    : directChanges
  const fieldChanges = hasEntries(normalizedDirectChanges?.fields)
    ? normalizedDirectChanges.fields
    : normalizedDirectChanges
  const details = hasEntries(fieldChanges)
    ? fieldChanges
    : hasEntries(metadataChanges)
    ? metadataChanges
    : hasEntries(metadataFields)
    ? metadataFields
    : {}
  return details && typeof details === "object" && !Array.isArray(details)
    ? Object.entries(details)
    : []
}

export const getActivityChangeValue = (change, side) => {
  if (change && typeof change === "object" && !Array.isArray(change)) {
    const alternateSide = side === "old" ? "before" : "after"
    const valueSide = side === "old" ? "old_value" : "new_value"
    if (Object.prototype.hasOwnProperty.call(change, side)) return change[side]
    if (Object.prototype.hasOwnProperty.call(change, alternateSide)) return change[alternateSide]
    if (Object.prototype.hasOwnProperty.call(change, valueSide)) return change[valueSide]
    return undefined
  }
  if (Array.isArray(change)) return change[side === "old" ? 0 : 1]
  return undefined
}

export const formatActivityValue = value => {
  if (value === null || value === undefined || value === "") return "—"
  if (typeof value === "object") {
    try {
      return JSON.stringify(value)
    } catch {
      return "—"
    }
  }
  return String(value)
}

export const getActivityDescription = activity => {
  const description = activity?.description || "No detailed changes available."
  const fullName =
    activity?.actioned_by_name ||
    activity?.created_by_name ||
    activity?.user_name
  if (!fullName || !/@/.test(description)) return description
  return description.replace(/[\w.+-]+@[\w.-]+\.[A-Za-z]{2,}/, fullName)
}

const activityLogInFlight = new Map()
const activityLogRecent = new Map()

const getActivityToken = () => {
  try {
    const userInfo = JSON.parse(sessionStorage.getItem("user-info") || "{}")
    return (
      userInfo?.token ||
      userInfo?.access_token ||
      sessionStorage.getItem("token") ||
      ""
    )
  } catch {
    return sessionStorage.getItem("token") || ""
  }
}

const sanitizeActivityPayload = payload => {
  const blocked = /password|token|secret|watch[_ ]?word|smtp/i
  const sanitize = value => {
    if (Array.isArray(value)) return value.map(sanitize)
    if (!value || typeof value !== "object") return value
    return Object.fromEntries(
      Object.entries(value)
        .filter(([key]) => !blocked.test(key))
        .map(([key, value]) => [key, sanitize(value)])
    )
  }
  return sanitize(payload)
}

export const trackActivity = async ({
  module,
  moduleName,
  pageUrl = window.location.pathname,
  action,
  actionType,
  recordType,
  recordId,
  companyId,
  metadata = {},
  screenshot,
}) => {
  const resolvedModule = module || moduleName
  if (!resolvedModule || !action) return
  const payload = sanitizeActivityPayload({
    module: resolvedModule,
    module_name: moduleName || resolvedModule,
    page_url: pageUrl,
    action,
    action_type: actionType || action,
    record_type: recordType,
    record_id: recordId,
    company_id: companyId,
    metadata,
    ...(screenshot ? { screenshot } : {}),
  })
  const dedupeKey = JSON.stringify(payload)
  const recentAt = activityLogRecent.get(dedupeKey)
  if (recentAt && Date.now() - recentAt < 5000) return
  if (activityLogInFlight.has(dedupeKey))
    return activityLogInFlight.get(dedupeKey)
  activityLogRecent.set(dedupeKey, Date.now())
  const configuredApiUrl = (
    process.env.REACT_APP_API_URL ||
    process.env.REACT_APP_API_BASE_URL ||
    ""
  ).replace(/\/$/, "")
  const request = fetch(`${configuredApiUrl}/api/v1/user-activity/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(getActivityToken()
        ? { Authorization: `Bearer ${getActivityToken()}` }
        : {}),
    },
    body: JSON.stringify(payload),
    keepalive: true,
  })
    .catch(() => undefined)
    .finally(() => activityLogInFlight.delete(dedupeKey))
  activityLogInFlight.set(dedupeKey, request)
  return request
}

export const trackUserActivity = options => trackActivity(options)
